module.exports = __webpack_public_path__ + "static/media/redCross.02eac858.svg";